import React, { FC } from 'react'
import { brandColors } from 'shared/basicPalette'
import IconInfo from '../icon/IconInfo'
import IconQuestion from '../icon/IconQuestion'
import Tooltip from './Tooltip'

interface TooltipIconProps {
  isBlock?: boolean
}

export const TooltipHelpQuestion: FC<TooltipIconProps> = ({
  children,
  isBlock = false
}) => {
  return (
    <Tooltip
      text={children}
      ml="8px"
      fontSize="16px"
      color={brandColors.grey.mid}
    >
      <IconQuestion isBlock={isBlock} />
    </Tooltip>
  )
}

export const TooltipHelpInfo: FC<TooltipIconProps> = ({
  children,
  isBlock = false
}) => {
  return (
    <Tooltip
      text={children}
      fontSize="16px"
      color={brandColors.grey.mid}
      ml="8px"
    >
      <IconInfo isBlock={isBlock} />
    </Tooltip>
  )
}
